import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3400">
      <Navbar data-id="element-3401" />
      <main data-id="element-3402">
        <ConsularAffairs data-id="element-3403" />
      </main>
      <Footer data-id="element-3404" />
      <FeedbackPopup data-id="element-3405" />
    </div>;
}